import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
import { FONT_SIZE, FONT_WEIGHT } from 'constants/design-system';

import { useScreenContext } from 'navigation/context/ScreenContextProvider';
import { AppSelectors } from 'store/App';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { SettingActions, SettingSelectors } from 'store/Settings';
import { UserSelectors } from 'store/User';
import { BaseButton } from 'components/BaseButton';

export const CollapsibleSection = () => {
  const isSidebarMinimized = useAppSelector(
    AppSelectors.selectIsSidebarMinimized,
  );

  const { screen } = useScreenContext();

  const isGridView = screen === 'chef';

  const isGridViewCollapse = useAppSelector(
    SettingSelectors.selectIsGridViewCollapsed,
  );

  const cardViewLayoutCollapsibility = useAppSelector(
    SettingSelectors.selectCardViewLayoutCollapsibility,
  );

  const dispatch = useAppDispatch();

  const featureFlagInterfaceSettings = useAppSelector(
    UserSelectors.selectInterfaceSettings,
  );
  const enableCollapsibleCards =
    featureFlagInterfaceSettings.enable_collapsible_cards;

  const { t } = useTranslation();

  if (!isGridView || !cardViewLayoutCollapsibility || !enableCollapsibleCards) {
    return null;
  }

  return (
    <View
      style={{
        paddingHorizontal: 8,
        marginTop: 8,
      }}
    >
      <BaseButton
        title={
          isSidebarMinimized
            ? ''
            : isGridViewCollapse
              ? t('sideBar.collapsible.expandAllCards')
              : t('sideBar.collapsible.collapseAllCards')
        }
        backgroundColor={isGridViewCollapse ? '#FF3232' : '#00E5BF'}
        color={isGridViewCollapse ? '#FFF' : '#242332'}
        fontSize={FONT_SIZE.theme.sm}
        fontWeight={FONT_WEIGHT.theme.medium}
        textAlign="left"
        onPress={() => {
          dispatch(SettingActions.setIsGridViewCollapsed(!isGridViewCollapse));
        }}
        style={[
          {
            paddingHorizontal: 12,
            paddingVertical: 6,
          },
          isSidebarMinimized && {
            paddingVertical: 10,
          },
        ]}
        endIcon={{
          variant: 'material-community',
          name: isGridViewCollapse
            ? 'arrow-expand-vertical'
            : 'arrow-collapse-up',
          size: FONT_SIZE.theme.xl,
        }}
      />
    </View>
  );
};
